import React, {useCallback, useEffect, useState, useRef} from 'react';
import AppContainer from '../Components/AppContainer';
import {StyleSheet} from 'react-native';
import {Box, Heading, Pressable, VStack, HStack} from 'native-base';
import main from '../../Assets/Styles/main.json';
import {createIconSetFromFontello} from 'react-native-vector-icons';
import lineAwesomeConfig from '../../Assets/Fontello/line-awesome-config.json';
import Trans from '../Components/Trans';
import UserAction from '../../Actions/UserAction';
import APIAction from '../../Actions/APIAction';

const Icon = createIconSetFromFontello(lineAwesomeConfig);
const mainStyle = StyleSheet.create(main);

const ReadOnlyMenuScreen = ({navigation}) => {
  const firstLoad = useRef(true);
  const [client, setClient] = useState(null);

  const onFirstLoad = useCallback(() => {
    const init = async () => {
      let user = await UserAction.getUser();
      let clientData = await APIAction.request({
        method: 'GET',
        url: user.client,
      });
      setClient(clientData);
    };
    init();
  }, []);

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      onFirstLoad();
    }
  }, [onFirstLoad]);

  const MenuItem = ({icon, title, onPress}) => (
    <Pressable onPress={onPress}>
      <Box style={mainStyle.whiteBox}>
        <HStack space={3} alignItems={'center'}>
          <Icon name={icon} size={24} color={'#333'} />
          <Heading size={'sm'}>{title}</Heading>
        </HStack>
      </Box>
    </Pressable>
  );

  return (
    <AppContainer>
      <VStack space={2}>
        <Box style={[mainStyle.pageTitleWrapper, {paddingBottom: 0}]}>
          <Box style={{flexGrow: 1}}>
            <Heading style={mainStyle.pageTitle}>
              <Trans>Documenten</Trans>
            </Heading>
          </Box>
        </Box>

        <VStack space={3} mt={4}>
          <MenuItem
            icon={'file-contract'}
            title={<Trans>Contracten</Trans>}
            onPress={() =>
              navigation.navigate('ContractsOverview', {
                clientId: client?.id,
                clientName: client?.name,
              })
            }
          />
          <MenuItem
            icon={'file-invoice'}
            title={<Trans>Facturen</Trans>}
            onPress={() => navigation.navigate('Invoices')}
          />
        </VStack>
      </VStack>
    </AppContainer>
  );
};

export default ReadOnlyMenuScreen;
